export const omitTypeName = <T>(data: T): T =>
  JSON.parse(JSON.stringify(data), (key, value) => (key === '__typename' ? undefined : value)) as T;

export const omitArrayTypeName = <T>(data: T[]) => data.map(omitTypeName);
